var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "40px",
    viewBox: "0 0 29.24 29.24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M14.62,0C6.55,0,0,6.55,0,14.62s6.55,14.62,14.62,14.62,14.62-6.55,14.62-14.62S22.7,0,14.62,0Zm-3.3,21h-2.83V11.9h2.83v9.1Zm-1.42-10.34c-.91,0-1.64-.74-1.64-1.64s.73-1.64,1.64-1.64,1.64,.73,1.64,1.64-.73,1.64-1.64,1.64Zm12.01,10.34h-2.83v-4.42c0-1.06-.02-2.41-1.47-2.41s-1.7,1.15-1.7,2.34v4.5h-2.83V11.9h2.71v1.24h.04c.38-.72,1.3-1.47,2.68-1.47,2.86,0,3.39,1.88,3.39,4.33v4.99Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.152b6e2a3979a27fb1b7feeef087a8e2.svg";
export { ForwardRef as ReactComponent };